export function getPromoCodeId(record) {
  return record?.promoCodeId ?? record?.promoCodeid ?? record?.PromoCodeId ?? record?.id ?? null;
}

export function isRevokedPromoRecord(record) {
  if (record?.isRevoked) return true;
  return String(record?.status ?? '').trim().toLowerCase() === 'revoked';
}

/** Cancel unused keys uses the row `remaining` count. */
export function getPromoRemainingCount(record) {
  const remaining = Number(record?.remaining);
  return Number.isFinite(remaining) && remaining > 0 ? remaining : 0;
}

function isActiveOrRevokedPromo(record) {
  if (isRevokedPromoRecord(record)) return true;
  return !record?.isExpired;
}

/** Show Cancel when unused keys remain and the promo is Active or Revoked. */
export function canCancelRevokedUnusedPromo(record) {
  return isActiveOrRevokedPromo(record) && getPromoRemainingCount(record) > 0 && !!getPromoCodeId(record);
}
